var _g, _rect, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    rx: 68,
    fill: "url(#paint0_linear_764_16566)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 135,
    height: 135,
    rx: 67.5,
    stroke: "#CFE5FF",
    strokeOpacity: 0.46
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_764_16566",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 136,
    height: 136
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 136,
    rx: 68,
    fill: "#E5F3FB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_764_16566)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7948 40.4251C53.2172 39.9809 54.0103 38.4679 53.5668 37.0448C53.1229 35.6217 51.6107 34.8276 50.1883 35.2718C48.766 35.7161 47.9729 37.2296 48.4163 38.6527C48.8603 40.0758 50.3725 40.8693 51.7954 40.4256M9.15332 56.6359L32.8951 49.2242C33.1454 47.2009 34.5457 45.402 36.6092 44.7577L44.5384 42.2822C45.7501 41.9041 46.433 40.602 46.0545 39.3891C45.2038 36.661 46.7245 33.7594 49.4511 32.9083C52.1778 32.0571 55.0779 33.5792 55.9292 36.3067C56.3076 37.5195 57.6091 38.2023 58.8208 37.8236L66.75 35.3481C68.8129 34.7044 70.9877 35.3871 72.3434 36.9091L96.0846 29.498L129.525 136.729C115.857 153.011 95.3605 163.364 72.4451 163.364C60.8724 163.364 49.9166 160.725 40.1448 156.015L9.15332 56.6359Z",
    fill: "#0E2F4D",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4993 49.7366L103.46 26.1548L132.179 133.389C118.591 151.586 96.8943 163.366 72.4463 163.366C62.5531 163.366 53.1122 161.432 44.4747 157.93L15.4993 49.7366Z",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1433 53.2351L101.186 31.5088L129.404 136.874C124.389 143.721 117.351 149.182 110.463 153.162C91.0496 164.38 69.3391 166.703 48.5917 159.463L20.1433 53.2351Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8167 32.4932C81.2075 33.138 82.3152 34.3707 82.7405 35.9594L84.1245 41.1267L43.2963 52.0724L41.9123 46.9051C41.487 45.3164 41.831 43.6954 42.7127 42.4408L79.8167 32.4932Z",
    fill: "#021A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7631 35.2722C60.2024 34.8862 61.0565 33.4066 60.6707 31.9665C60.2849 30.5265 58.806 29.6719 57.3667 30.058C55.9274 30.444 55.0733 31.9236 55.4591 33.3636C55.8449 34.8037 57.3238 35.6582 58.7631 35.2722ZM43.4136 38.9843L51.4366 36.8332C52.663 36.5049 53.3979 35.2315 53.0691 34.0046C52.3297 31.2437 53.9673 28.4065 56.7261 27.6667C59.4855 26.9275 62.3212 28.5653 63.0607 31.3256C63.3894 32.5526 64.6621 33.2879 65.8879 32.959L73.9108 30.8079C76.7522 30.0461 79.6986 31.7484 80.46 34.5912L81.844 39.7591L41.0157 50.7048L39.6318 45.5369C38.8709 42.6941 40.5717 39.7456 43.4131 38.9843H43.4136Z",
    fill: "#AFD5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0801 36.8997L40.2522 47.8452L41.0179 50.7042L81.8457 39.7587L81.0801 36.8997Z",
    fill: "#3D73B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3055 68.5021L33.0328 71.5241L36.0532 82.8027L47.3259 79.7807L44.3055 68.5021ZM32.0476 70.413L44.6026 67.0468L45.2437 66.875L45.4155 67.5165L48.7793 80.078L48.951 80.7195L48.3099 80.8913L35.7549 84.2574L35.1138 84.4292L34.9421 83.7878L31.5782 71.2263L31.4065 70.5848L32.0476 70.413V70.413Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.275 80.2705C41.0225 80.3383 40.744 80.3094 40.4999 80.1687L36.2425 77.7091C35.5059 77.2835 35.2528 76.3385 35.6781 75.6021C36.1035 74.8657 37.048 74.6119 37.784 75.0375L40.2565 76.4657L44.2829 69.4881C44.7083 68.7517 45.6528 68.4985 46.3888 68.9235C47.1248 69.3491 47.3779 70.294 46.9531 71.0304L41.8958 79.7946C41.7551 80.0387 41.528 80.2026 41.275 80.2705",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9603 93.3478C47.2028 94.3555 43.4452 95.3626 39.6876 96.3697C40.6943 100.129 41.7014 103.889 42.708 107.648C46.4656 106.641 50.2232 105.633 53.9807 104.626C52.9741 100.867 51.967 97.1073 50.9603 93.3478M38.7025 95.2586C42.8877 94.1367 47.0729 93.0149 51.2575 91.893C51.471 91.8359 51.6851 91.7783 51.8986 91.7212C51.9557 91.9348 52.0133 92.149 52.0703 92.3627C53.1916 96.55 54.3129 100.737 55.4342 104.924C55.4918 105.138 55.5489 105.352 55.6059 105.566C55.3924 105.623 55.1783 105.68 54.9648 105.737C50.7796 106.859 46.595 107.982 42.4098 109.104C42.1963 109.161 41.9822 109.218 41.7686 109.275C41.7116 109.062 41.654 108.848 41.5969 108.634C40.4756 104.447 39.3538 100.259 38.2325 96.0719C38.1755 95.8582 38.1178 95.6441 38.0608 95.4304C38.2743 95.3733 38.4884 95.3157 38.7019 95.2586H38.7025Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9282 105.117C47.6757 105.185 47.3972 105.156 47.1532 105.015C45.7337 104.195 44.3147 103.376 42.8952 102.556C42.1591 102.13 41.9061 101.185 42.3308 100.449C42.7562 99.7124 43.7007 99.4592 44.4367 99.8842C45.2609 100.36 46.0845 100.837 46.9092 101.312C48.2513 98.9867 49.5935 96.661 50.9356 94.3348C51.361 93.5984 52.3055 93.3452 53.0415 93.7702C53.7775 94.1957 54.0306 95.1407 53.6058 95.8771C51.9202 98.7985 50.234 101.72 48.5485 104.641C48.4072 104.885 48.1802 105.049 47.9277 105.117",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6136 118.197C53.856 119.205 50.0985 120.212 46.3409 121.219C47.3475 124.979 48.3547 128.738 49.3613 132.498C53.1189 131.491 56.8764 130.483 60.634 129.476C59.6274 125.716 58.6202 121.957 57.6136 118.197M45.3557 120.108C49.5409 118.986 53.7261 117.864 57.9107 116.742C58.1242 116.685 58.3383 116.627 58.5519 116.57C58.6089 116.784 58.6665 116.998 58.7236 117.212C59.8449 121.399 60.9661 125.587 62.088 129.774C62.145 129.987 62.2027 130.202 62.2597 130.415C62.0462 130.472 61.8321 130.53 61.6186 130.587C57.434 131.709 53.2488 132.831 49.0636 133.953C48.8501 134.01 48.636 134.067 48.4225 134.125C48.3654 133.911 48.3078 133.697 48.2507 133.483C47.1295 129.296 46.0082 125.108 44.8863 120.922C44.8293 120.708 44.7717 120.494 44.7146 120.28C44.9281 120.223 45.1422 120.165 45.3557 120.108V120.108Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.583 129.963C54.3305 130.031 54.052 130.003 53.808 129.862C52.3885 129.042 50.9695 128.222 49.5499 127.402C48.8139 126.977 48.5608 126.032 48.9856 125.295C49.411 124.559 50.3555 124.305 51.0915 124.731C51.9157 125.207 52.7398 125.683 53.564 126.159C54.9061 123.833 56.2483 121.508 57.5904 119.181C58.0158 118.445 58.9602 118.192 59.6963 118.617C60.4323 119.042 60.6859 119.987 60.2606 120.724C58.575 123.645 56.8888 126.567 55.2032 129.488C55.062 129.732 54.8355 129.896 54.5824 129.964",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4126 59.7093L52.0806 71.8623L52.3801 72.9809L97.7122 60.8279L97.4126 59.7093Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1728 65.1256L53.3518 76.6055L53.6514 77.724L96.4724 66.2442L96.1728 65.1256Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6237 57.5143L50.8113 67.1152L51.1108 68.2338L86.9233 58.6329L86.6237 57.5143Z",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.8 84.3618L58.7358 96.7109L59.0354 97.8295L105.099 85.4803L104.8 84.3618Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0167 91.5329L60.0061 101.455L60.3057 102.574L97.3163 92.6515L97.0167 91.5329Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.285 80.486L57.4644 91.9658L57.7639 93.0844L100.585 81.6046L100.285 80.486Z",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8981 113.111L65.3901 121.558L65.6897 122.676L97.1977 114.229L96.8981 113.111Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9798 119.514L66.6604 126.302L66.96 127.42L92.2794 120.632L91.9798 119.514Z",
    fill: "#7CB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.941 105.334L64.1189 116.814L64.4185 117.933L107.24 106.453L106.941 105.334Z",
    fill: "#0762C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.785 131.737L70.7739 141.659L71.0735 142.778L108.084 132.856L107.785 131.737Z",
    fill: "#0762C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_764_16566",
    x1: 3.5935,
    y1: 136,
    x2: 133.236,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7EE",
    stopOpacity: 0.37
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1);
export default __webpack_public_path__ + "static/media/slide1.dcadfbcbb47fbe381b1d8d224f0471cd.svg";
export { ForwardRef as ReactComponent };